module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","search_placeholder":"Search"},"fr":{"search":"Recherche","search_placeholder":"Rechercher"}}')
  delete Component.options._Ctor
}
